import { createApp } from 'vue'
import App from './App.vue'
import router from './router/index.js'
import './styles/tokens.css'

const app = createApp(App).use(router)

// Keep the server-rendered boot screen visible while the initial auth guard
// restores the cookie session and resolves the authoritative workspace route.
router.isReady()
  .catch(() => undefined)
  .finally(() => app.mount('#app'))
